<template>
    <div :style="{display:show?'block':'none'}" style="position: absolute;top:0;width: 100%;height:100%;background: rgba(1,1,1,0.5); z-index: 9999999;"  @click="$emit('clicked')"></div>
</template>
<script>
    import modalX from './ModalX.vue';

    export default {
        components: {
            modalX: modalX,
        },
        props: ["show"],
        methods: {

        }
    }
</script>